export default `# James Chen

A full-stack JS developer.

## Contact

| [GitHub](https://github.com/ChenjxJames) | [Email](mailto:james@chenjx.com.cn) | [Blog](https://www.chenjianxiong.com)

## Teck Stack

- Backend: Node.js; koa2; egg.js; Python; Django
- Database: MySQL; MongoDB; Redis
- Frontend: react.js; vue.js; sass/less; Redux; Typescript

## Projects (open source)

- **[none-sql](https://github.com/ChenjxJames/none-sql)**: npm~~~~ package.
  - Developed based on the npm open-source library MySQL, it has added Promise style methods and chain call programming methods for commonly used database operations;
  - Implement commonly used database operation APIs, and complete simple database operations without the need to write SQL statements.
  - install:
    \`\`\`
    npm install none-sql
    # or
    yarn add none-sql
    \`\`\`

## Working Experience

- maintain secrecy

## Education

- Bachelor’s Degree in Computer Science and Technology, **Shanghai Sanda University** *(2016 – 2020)*
`